import { render, staticRenderFns } from "./Product-Dropdown.vue?vue&type=template&id=b4111c06"
import script from "./Product-Dropdown.vue?vue&type=script&lang=js"
export * from "./Product-Dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports